/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/file_xml_medium'
export default icon
